import { useState } from "react";
import styles from './Documents.module.css'
import { AddModificationPolicy } from "./AddModificationPolicy";
import { AddCancellationPolicy } from "./AddCancellationPolicy";
import { AddContract } from "./AddContract";
import { DeleteContract } from "./DeleteContract";
import { DeleteModificationPolicy } from "./DeleteModificationPolicy";
import { DeleteCancellationPolicy } from "./DeleteCancellationPolicy";
import { downloadContract, downloadCancellationPolicy, downloadModificationPolicy } from "../../../store/slices/files/thunks";
import { useDispatch } from "react-redux";



export const Documents = ({ file }) => {
  const dispatch = useDispatch();

  const [addContract, setAddContract] = useState(false);
  const [addModificationPolicy, setAddModificationPolicy] = useState(false);
  const [addCancellationPolicy, setAddCancellationPolicy] = useState(false);
  const [deleteContract, setDeleteContract] = useState(false);
  const [deleteModificationPolicy, setDeleteModificationPolicy] = useState(false);
  const [deleteCancellationPolicy, setDeleteCancellationPolicy] = useState(false);

  return (
    <>
    <div style={{ marginTop: 20, marginBottom: 20 }}>        
        {
          file.contract 
          ? <div>
            <button className="btn btn-danger btn-icon" onClick={() => setDeleteContract(true)} >Eliminar Contrato</button>
            <label className={`${styles.download}`} onClick={() => dispatch(downloadContract(file.contract))}>Descargar Contrato</label>
          </div>
          : <button className="btn btn-light btn-icon"
          onClick={() => setAddContract(true)} >Agregar Contrato</button>
        }
      </div>
      <AddContract file={file} isOpen={addContract} setIsOpen={setAddContract} />
      <DeleteContract file={file} isOpen={deleteContract} setIsOpen={setDeleteContract} />

      <div style={{ marginTop: 20, marginBottom: 20 }}>        
        {
          file.modificationPolicy 
          ? <div>
            <button className="btn btn-danger btn-icon" onClick={() => setDeleteModificationPolicy(true)} >Eliminar Politica De Modificacion</button>
            <label className={`${styles.download}`} onClick={() => dispatch(downloadModificationPolicy(file.modificationPolicy))}>Descargar Politica De Modificacion</label>
          </div>
          : <button className="btn btn-light btn-icon"
          onClick={() => setAddModificationPolicy(true)} >Agregar Politica De Modificacion</button>
        }
      </div>
      <AddModificationPolicy file={file} isOpen={addModificationPolicy} setIsOpen={setAddModificationPolicy} />
      <DeleteModificationPolicy file={file} isOpen={deleteModificationPolicy} setIsOpen={setDeleteModificationPolicy} />

      <div style={{ marginTop: 20, marginBottom: 20 }}>        
        {
          file.cancellationPolicy 
          ? <div>
            <button className="btn btn-danger btn-icon" onClick={() => setDeleteCancellationPolicy(true)} >Eliminar Politica De Cancelacion</button>
            <label className={`${styles.download}`} onClick={() => dispatch(downloadCancellationPolicy(file.cancellationPolicy))}>Descargar Politica De Cancelacion</label>
          </div>
          : <button className="btn btn-light btn-icon"
          onClick={() => setAddCancellationPolicy(true)} >Agregar Politica De Cancelacion</button>
        }
      </div>
      <AddCancellationPolicy file={file} isOpen={addCancellationPolicy} setIsOpen={setAddCancellationPolicy} />
      <DeleteCancellationPolicy file={file} isOpen={deleteCancellationPolicy} setIsOpen={setDeleteCancellationPolicy} />
    </>
  )
}
